import axios from 'axios';

export const API_URL = '/api';
export const MENTION_SEPARATOR = '\u200b';
export const MENTION_REGEX = /@([^\u200b@\n\r]+?)(?:\s+\(([^)\n\r]+)\))?\u200b/g;

const TYPE_ALIAS = {
  player: 'player_character',
  character: 'player_character',
  characters: 'player_character',
  personnage: 'player_character',
  personnages: 'player_character',
  pj: 'player_character',
  npc: 'npc',
  pnj: 'npc',
  quest: 'quest',
  quests: 'quest',
  quete: 'quest',
  quetes: 'quest',
  location: 'location',
  locations: 'location',
  lieu: 'location',
  lieux: 'location',
  lore: 'lore',
  map: 'map',
  maps: 'map',
  carte: 'map',
  cartes: 'map',
  pin: 'pin',
  pins: 'pin',
  encounter: 'encounter',
  encounters: 'encounter',
  rencontre: 'encounter',
  rencontres: 'encounter',
  treasure: 'treasure',
  treasures: 'treasure',
  tresor: 'treasure',
  tresors: 'treasure',
  session: 'session',
  sessions: 'session'
};

const normalize = (value) =>
  (value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');

export const resolveTypeFromLabel = (label) => TYPE_ALIAS[normalize(label)] || null;

export const buildMentionToken = (item, language = 'fr') => {
  const typeLabel = language === 'fr' ? item.type_label_fr : item.type_label_en;
  return `@${item.name} (${typeLabel})${MENTION_SEPARATOR}`;
};

export const extractMentionTokens = (text) => {
  if (!text) return [];
  const matches = [];
  for (const match of text.matchAll(MENTION_REGEX)) {
    matches.push({
      raw: match[0],
      label: (match[1] || '').trim(),
      typeLabel: (match[2] || '').trim()
    });
  }
  return matches;
};

export const resolveEntityRoute = (campaignId, entityType, entityId) => {
  if (!campaignId || !entityType || !entityId) return null;
  if (entityType === 'npc') return `/campaigns/${campaignId}/npcs/${entityId}`;
  if (entityType === 'quest') return `/campaigns/${campaignId}/quests/${entityId}`;
  if (entityType === 'location') return `/campaigns/${campaignId}/locations/${entityId}`;
  if (entityType === 'session') return `/campaigns/${campaignId}/sessions/${entityId}`;
  if (entityType === 'lore') return `/campaigns/${campaignId}/lore?article=${entityId}`;
  if (entityType === 'map') return `/campaigns/${campaignId}/maps?mapId=${entityId}`;
  if (entityType === 'pin') return `/campaigns/${campaignId}/maps`;
  if (entityType === 'encounter') return `/campaigns/${campaignId}/combat`;
  if (entityType === 'treasure') return `/campaigns/${campaignId}/treasure`;
  return null;
};

export const syncEntityMentions = async ({ campaignId, sourceType, sourceId, sourceFields }) => {
  if (!campaignId || !sourceType || !sourceId) return;
  await axios.post(`${API_URL}/campaigns/${campaignId}/mentions/sync`, {
    source_type: sourceType,
    source_id: sourceId,
    source_fields: sourceFields || {}
  });
};

